import { Home, Ruler, Lightbulb } from "lucide-react";

const groepen = [
  {
    icon: Home,
    titel: "Particulieren thuis",
    tekst: "Die ene speciale kast, tafel of wijnopslag die nergens standaard te koop is.",
  },
  {
    icon: Ruler,
    titel: "Stylisten & Ontwerpers",
    tekst: "Vaste ambachtspartner die schetsen en interieurplannen betrouwbaar uitvoert.",
  },
  {
    icon: Lightbulb,
    titel: "Iedereen met een idee",
    tekst: "Van een simpel krabbeltje tot uitgewerkt plan: René helpt het realiseren.",
  },
];

export const Audiences = () => (
  <section data-testid="audiences-section" className="py-20 px-6 max-w-7xl mx-auto border-b border-[#EAE3DA]">
    <div className="max-w-2xl mb-12 hr-reveal">
      <span className="text-xs uppercase tracking-widest text-[#9C6D3B] font-bold">Doelgroepen</span>
      <h2 className="text-3xl font-normal font-display text-[#2B231D] mt-2">
        Voor wie wij hout tot leven wekken
      </h2>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {groepen.map((g, i) => (
        <div
          key={g.titel}
          data-testid={`audience-card-${i}`}
          className="p-6 rounded-2xl bg-white border border-[#EAE3DA] hr-reveal"
        >
          <div className="w-10 h-10 rounded-xl bg-[#F4EFEA] flex items-center justify-center text-[#9C6D3B] mb-4">
            <g.icon size={20} />
          </div>
          <h3 className="text-lg font-bold text-[#2B231D] mb-2 font-display">{g.titel}</h3>
          <p className="text-xs text-[#6C5E52] leading-relaxed">{g.tekst}</p>
        </div>
      ))}
    </div>
  </section>
);
